import { render, staticRenderFns } from "./BtnRow.vue?vue&type=template&id=0d818e02&scoped=true&"
var script = {}
import style0 from "./BtnRow.vue?vue&type=style&index=0&id=0d818e02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d818e02",
  null
  
)

export default component.exports